module.exports = __webpack_public_path__ + "img/icon_shidu.83d87ddd.png";